import { render } from "./CheckoutPay.vue?vue&type=template&id=187b9fce"
import script from "./CheckoutPay.vue?vue&type=script&lang=js"
export * from "./CheckoutPay.vue?vue&type=script&lang=js"

import "./CheckoutPay.vue?vue&type=style&index=0&id=187b9fce&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "187b9fce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('187b9fce', script)) {
    api.reload('187b9fce', script)
  }
  
  module.hot.accept("./CheckoutPay.vue?vue&type=template&id=187b9fce", () => {
    api.rerender('187b9fce', render)
  })

}

script.__file = "src/views/payments/modules/checkout/CheckoutPay.vue"

export default script